import { render, staticRenderFns } from "./interStaffList.vue?vue&type=template&id=519357ac&scoped=true"
import script from "./interStaffList.vue?vue&type=script&lang=js"
export * from "./interStaffList.vue?vue&type=script&lang=js"
import style0 from "./interStaffList.vue?vue&type=style&index=0&id=519357ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519357ac",
  null
  
)

export default component.exports